<script setup>
import { computed, inject } from "vue";
import ButtonLink from "@/Components/Button/Link.vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

  <template>
  <div class="section-container">
    <div class="grid md:grid-cols-2 gap-8 items-center">
      <!-- Left Content -->
      <div>
        <h2
          class="text-4xl md:text-5xl"
        >{{ $t('Neem Contact met Ons Op: Laat Ons Weten Hoe We U Kunnen Helpen') }}</h2>
        <p
          class="mt-2 text-lg mt-4"
        >{{ $t('Heeft u vragen of wilt u meer informatie over onze diensten? Neem dan gerust contact met ons op. Of het nu gaat om advies of directe inzet van professionals: wij staan klaar om u snel en deskundig te ondersteunen.') }}</p>
        <ButtonLink
          :href="route('contact')"
          class="bg-[#437066] text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-[#355a50] transition mt-4"
        >{{ $t('Neem contact op') }}</ButtonLink>
      </div>

      <!-- Right Image -->
      <div class="flex justify-center">
        <img
          src="@/../img/home/match-platform.jpg"
          alt="Match Platform"
          class="max-w-full rounded-lg shadow-md"
        />
      </div>
    </div>
  </div>
</template>